import { render, staticRenderFns } from "./RepoDetail.vue?vue&type=template&id=72fb874b&"
import script from "./RepoDetail.vue?vue&type=script&lang=js&"
export * from "./RepoDetail.vue?vue&type=script&lang=js&"
import style0 from "./RepoDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports